/* eslint-disable no-unused-vars, react/self-closing-comp */

import { ButtonBase } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { KeyboardArrowDown } from '@material-ui/icons'
import * as Pickr from '@simonwep/pickr'
import cn from 'classnames'
import React from 'react'
import '@simonwep/pickr/dist/themes/monolith.min.css'

import LabelWrapper from '../LabelWrapper'

const styles = theme => ({
  bordered: {
    borderBottom: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    paddingBottom: '8px',
  },
  colorSelect: {
    minWidth: '190px',
    height: '36px',
    padding: '0 10px',
    backgroundColor: `var(--gameday-inputField-colorPickerBg, ${theme.inputField.colorPickerBg})`,
    border: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
    borderRadius: '4px',
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    justifyContent: 'space-between',
    '&.Mui-disabled': {
      color: `${`var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`} !important`,
      backgroundColor: `${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`} !important`,
    },
  },
  icon: {
    marginLeft: '6px',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
  previewSwatch: {
    display: 'inline-block',
    width: '20px',
    height: '20px',
    marginRight: '8px',
    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 0px 1px inset',
    borderRadius: '10px',
  },
  picker: {
    margin: '10px',
  },
  pickerDialog: {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.4)',
    border: theme.borders.default,
    backgroundColor: `var(--gameday-inputField-colorPickerBg, ${theme.inputField.colorPickerBg})`,
    borderRadius: '4px',
    '& .pcr-interaction': {
      flexWrap: 'nowrap',
    },
    '&.pcr-app .pcr-interaction input': {
      display: 'flex',
      alignItems: 'center',
      height: '28px',
      padding: '0 8px',
      borderRadius: theme.borders.borderRadius,
      fontFamily: theme.typography.defaultFont,
      letterSpacing: 'normal',
      '&:focus': {
        boxShadow: 'none',
      },
    },
    '&.pcr-app .pcr-interaction input.pcr-result': {
      background: `var(--gameday-buttons-actionButtonBg, ${theme.buttons.actionButtonBg})`,
      border: `1px solid var(--gameday-borders-borderColor, ${theme.borders.borderColor})`,
      borderRadius: theme.borders.borderRadius,
      color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
      '&:focus': {
        borderColor: theme.borders.borderColorActive,
      },
    },
    '&.pcr-app .pcr-interaction .pcr-save': {
      backgroundColor: theme.borders.borderColorActive,
      fontWeight: 500,
    },
    '&.pcr-app .pcr-interaction .pcr-cancel': {
      border: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
      backgroundColor: `var(--gameday-buttons-actionButtonBg, ${theme.buttons.actionButtonBg})`,
      color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
      fontWeight: 500,
    },
  },
})

class ColorPicker extends React.Component {
  componentDidMount() {
    const pickr = Pickr.create({
      el: `.color-picker-${this.props.name}`,
      theme: 'monolith',
      swatches: this.props.otherColors,
      useAsButton: true,
      adjustableNumbers: true,
      default: this.props.color || '#ffffff',
      defaultRepresentation: 'HEX',
      appClass: this.props.classes.pickerDialog,
      disabled: this.props.disabled,
      padding: 0,
      components: {
        palette: true,
        preview: false,
        hue: true,
        interaction: {
          input: true,
          save: true,
          cancel: true,
        },
      },
      strings: {
        save: 'Apply',
        cancel: 'Cancel',
      },
    })
    pickr
      // biome-ignore lint/correctness/noUnusedVariables: TODO
      .on('init', instance => {})
      // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
      .on('save', (color, instance) => {
        const colorString = color.toHEXA().toString()
        this.props.onColorChange(this.props.id, colorString)
        pickr.hide()
      })
      // biome-ignore lint/correctness/noUnusedVariables: TODO
      .on('cancel', instance => {
        pickr.hide()
      })
  }

  render() {
    const {
      classes,
      className,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      color,
      disabled,
      errorText,
      fullWidth,
      helperText,
      id,
      isLabelInline,
      isRequired,
      isToolTip,
      justify,
      label,
      multipleFields,
      name,
      noMobile,
      noWrap,
      // biome-ignore lint/correctness/noUnusedVariables: TODO
      onColorChange,
      // biome-ignore lint/correctness/noUnusedVariables: TODO
      otherColors,
      placeholder,
      showActionLink,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      withBorder,
      withDivider,
    } = this.props

    return (
      <LabelWrapper
        className={cn({ disabled, errorText }, classes.root, className)}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        customWidth={customWidth}
        disabled={disabled}
        errorText={errorText}
        fullWidth={fullWidth}
        helperText={helperText}
        id={id}
        isLabelInline={isLabelInline}
        isRequired={isRequired}
        isToolTip={isToolTip}
        justify={justify}
        label={label}
        multipleFields={multipleFields}
        noMobile={noMobile}
        noWrap={noWrap}
        showActionLink={showActionLink}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        withBorder={withBorder}
        withDivider={withDivider}
      >
        <ButtonBase
          className={cn(classes.colorSelect, `color-picker-${name}`)}
          disabled={disabled}
          style={customWidth ? { width: `${customWidth}px` } : {}}
          aria-label="Select color"
        >
          {color ? (
            <div className={classes.label}>
              <span className={classes.previewSwatch} style={{ backgroundColor: color }} />
              {color}
            </div>
          ) : (
            placeholder
          )}
          <KeyboardArrowDown />
        </ButtonBase>
        <div className="color-picker"></div>
      </LabelWrapper>
    )
  }
}

ColorPicker.defaultProps = {
  classes: {},
  isLabelInline: false,
  label: '',
  otherColors: [],
  placeholder: 'Select Colour',
  withBorder: true,
}

const ColorPickerComponent = withStyles(styles)(ColorPicker)
ColorPickerComponent.displayName = 'ColorPicker'
export default ColorPickerComponent
